import { useState } from 'react';

export type NewsCategory = 'general' | 'world' | 'technology';

export const useCategory = (defaultCategory: NewsCategory = 'general') => {
  const [selectedCategory, setSelectedCategory] =
    useState<NewsCategory>(defaultCategory);

  return {
    selectedCategory,
    setSelectedCategory,
  };
};
